export default __webpack_public_path__ + "static/media/stronghold.2d030bab.svg";